import './App.css';
import { useMemo } from 'react';

import Home from './Home';

import * as anchor from '@project-serum/anchor';
import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
} from '@solana/wallet-adapter-wallets';

import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';

import { WalletDialogProvider } from '@solana/wallet-adapter-material-ui';
import { ThemeProvider, createTheme } from '@material-ui/core';

const theme = createTheme({
  palette: {
    type: 'dark',
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const fairLaunchId = new anchor.web3.PublicKey(
  process.env.REACT_APP_FAIR_LAUNCH_ID!,
);

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet()],
    [],
  );

  return (
    <ThemeProvider theme={theme}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletDialogProvider>
            <div className="px-4 py-16 sm:px-0 flex flex-col">
              <header className="mb-4 flex flex-col text-center">
                <h1
                  className="mx-auto sm:text-5xl text-3xl font-medium leading-tight text-gray-100"
                >
                  The Tower: Mint a Residence
                </h1>
                <h2
                  className="mx-auto mt-4 max-w-2xl text-lg font-normal leading-tight text-gray-300"
                >
                  🏗 Minting available here. Watch our <a
                    className="text-[color:#e3af0b] underline"
                    href="https://twitter.com/TowerDao"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Twitter
                  </a> for live updates. 🏗
                </h2>
                <h2
                  className="mx-auto mt-4 max-w-2xl text-lg font-normal leading-tight text-gray-300"
                >
                  ▶ Watch the <a
                    className="text-[color:#e3af0b] underline"
                    href="https://youtu.be/eYSontZOW0E"
                    target="_blank"
                    rel="noreferrer"
                  >
                    video
                  </a> on how this works. ▶
                </h2>
              </header>

              <div className="my-14">
                <Home
                  candyMachineId={candyMachineId}
                  fairLaunchId={fairLaunchId}
                  connection={connection}
                  startDate={startDateSeed}
                  txTimeout={txTimeout}
                />
              </div>
            </div>
          </WalletDialogProvider>
        </WalletProvider>
      </ConnectionProvider>
    </ThemeProvider>
  );
};

export default App;
